import { z } from 'zod';
/**
 * Client-side environment variables schema (PUBLIC_ prefix)
 * These variables are exposed to the browser and validated at runtime
 */ export const clientSchema = {
    PUBLIC_ENV: z.enum([
        'local',
        'development',
        'preview',
        'prerelease',
        'production'
    ]),
    PUBLIC_CORE_API_BASE_URL: z.string().url(),
    PUBLIC_AUTH_API_BASE_URL: z.string().url(),
    PUBLIC_FEEDBACK_API_URL: z.string().url(),
    PUBLIC_STRIPE_PK_KEY: z.string().min(1),
    PUBLIC_STRIPE_PRICE_PERSONAL: z.string().default(''),
    PUBLIC_STRIPE_PRICE_STANDARD: z.string().default(''),
    PUBLIC_STRIPE_PRICE_USERS: z.string().default(''),
    PUBLIC_CERBOS_HUB_BUNDLE_URL: z.string().url(),
    PUBLIC_USE_SENTRY: z.coerce.boolean().default(false),
    PUBLIC_SENTRY_DSN: z.string().default(''),
    PUBLIC_SENTRY_RELEASE: z.string().default(''),
    PUBLIC_INTERCOM_APP_ID: z.string().optional(),
    PUBLIC_GTM_ID: z.string().min(1)
};
/**
 * Server-side environment variables schema
 * These variables are only available on the server and never exposed to the browser
 */ export const serverSchema = {};
